import React, { useState } from 'react'
import {
  Alert,
  Button,
  Col,
  Container,
  Form,
  FormGroup,
  Input,
  Modal,
  ModalBody,
  ModalHeader,
  Row
} from 'reactstrap'
import { Label } from './RequestAccessStyledComponents'
import { FormattedMessage } from 'react-intl'
import PropTypes from 'prop-types'
import isValidEmail from '../../../helpers/emailValidation'
import { Mutation } from 'react-apollo'
import gqlStoreService from '../../../api/gql-query/storeQuery'

const RequestAccessModal = React.memo(
  ({ toggle, isOpen, storeId, onRequestSend }) => {
    const [email, onEmailChange] = useState('')
    const [reason, onReasonChange] = useState('')
    const [invalidMail, onValidationChange] = useState(false)

    const requestAccess = (e, requestPrivateStoreAccess) => {
      if (isValidEmail(email)) {
        requestPrivateStoreAccess({
          variables: {
            storeId,
            email,
            reason
          }
        })
      } else {
        onValidationChange(true)
      }
    }

    const requestAccessSuccess = data => {
      if (!data.requestPrivateStoreAccess.errors) {
        toggle()
        onRequestSend()
      }
    }

    return (
      <Modal isOpen={isOpen} toggle={toggle} size='lg'>
        <ModalHeader className='text-center' toggle={toggle}>
          <FormattedMessage id='general.requestAccess' />
        </ModalHeader>
        <ModalBody>
          <Container fluid className='mt-5 mb-5'>
            <Row>
              <Col md={{ size: 12 }}>
                <Mutation
                  mutation={gqlStoreService.requestPrivateStoreAccess}
                  onCompleted={requestAccessSuccess}
                >
                  {(requestPrivateStoreAccess, { error, data }) => (
                    <Form className='d-flex flex-column'>
                      {error && <Alert color='danger'>{error.message}</Alert>}
                      {data && data.requestPrivateStoreAccess.errors && (
                        <Alert color='danger'>
                          {data.requestPrivateStoreAccess.errors.map(
                            ({ messages }) =>
                              messages.map((message, i) => (
                                <span key={`msg-${i}`}>{message}</span>
                              ))
                          )}
                        </Alert>
                      )}
                      <FormGroup>
                        <Input
                          type='email'
                          name='email'
                          id='exampleEmail'
                          onChange={e => onEmailChange(e.target.value)}
                        />
                        <Label for='exampleEmail' invalidMail={invalidMail}>
                          <FormattedMessage id='general.email' />
                        </Label>
                      </FormGroup>
                      <FormGroup>
                        <Input
                          type='textarea'
                          name='text'
                          rows='1'
                          id='exampleText'
                          onChange={e => onReasonChange(e.target.value)}
                        />
                        <Label for='exampleText'>
                          <FormattedMessage id='general.reason' />
                        </Label>
                      </FormGroup>
                      <Button
                        className='align-self-end'
                        onClick={e =>
                          requestAccess(e, requestPrivateStoreAccess)
                        }
                      >
                        <FormattedMessage id='contact.send' />
                      </Button>
                    </Form>
                  )}
                </Mutation>
              </Col>
            </Row>
          </Container>
        </ModalBody>
      </Modal>
    )
  }
)

RequestAccessModal.displayName = 'RequestAccessModal'

RequestAccessModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  toggle: PropTypes.func.isRequired,
  storeId: PropTypes.string.isRequired,
  onRequestSend: PropTypes.func.isRequired
}

export default RequestAccessModal
